export function AccessibilityNB() {
  return (
    <article>
      <h1>Tilgjengelighetserklæring</h1>

      <h2>Vårt mål for universell utforming</h2>
      <p>
        Vi ønsker at skylagringstjenesten vår med nettsted, web-klient, mobil-
        og skrivebords-apper skal være tilgjengelig og enkel å bruke for alle.
      </p>
      <ul>
        <li>
          Minimum WCAG 2.1 nivå AA for alle nye leveranser; vi arbeider
          langsiktig mot nivå AAA der det er praktisk mulig.
        </li>
        <li>
          Løpende oppfølging av WCAG-krav gjennom design-, utviklings- og
          testprosessen.
        </li>
        <li>
          Tredjepartsløsninger (f.eks. Microsoft Office Online-redigering)
          kontrolleres for å sikre at de oppfyller norske krav til universell
          utforming.
        </li>
      </ul>

      <h2>Hvor tilgjengelig er tjenestene våre?</h2>
      <p>
        Vi har fremdeles deler av løsningen som ikke fullt ut oppfyller WCAG
        2.1, men vi arbeider aktivt for å lukke gapet.
      </p>
      <ul>
        <li>
          2023 – 2024: Vi bygget et nytt designsystem; alle nye
          grensesnittkomponenter er utviklet med WCAG 2.1 nivå AA som
          minimumskrav.
        </li>
        <li>
          2025 – 2026: Trinnvis utrulling av designsystemet i web-klienten samt
          mobil- og skrivebords-appene. Hver tjeneste som lanseres i «ny drakt»
          kvalitetssikres mot WCAG 2.1 før publisering.
        </li>
      </ul>

      <h2>Kjente tilgjengelighetsavvik og planlagte løsninger</h2>

      <ul>
        <li>
          Alt ikke-tekstlig innhold skal ha maskinlesbare tekstalternativer (A)
          - Ryddes i forbindelse med redesign Q4 2025
        </li>
        <li>
          Noen undersider i administrasjonsgrensesnittet mangler beskrivende
          titler (A) - Implementeres sammen med ny header-komponent Q1 2026
        </li>
        <li>
          All funksjonalitet må være tilgjengelig via tastatur (mangler i
          desktop-appene)) (A) - Tastaturhandlinger legges til fortløpende –
          start Q3 2025
        </li>
        <li>
          Sekvensiell fokusrekkefølge mangler i enkelte desktop-dialoger (A)
          Implementeres innen Q1 2026
        </li>
        <li>
          «Hopp til hovedinnhold» mangler i mobil-web (A) - Implementeres Q3
          2025
        </li>
        <li>
          Skjermleserstøtte (JAWS, NVDA, VoiceOver) mangler i desktop-appen (A)
          - Implementeres innen Q2 2026
        </li>
        <li>
          Inkonsekvent bruk av UI-komponenter på tvers av sider (AA) - Utredes
          innen Q4 2025
        </li>
        <li>
          Ikke alle drag-and-drop-operasjoner har fullgodt tastaturalternativ
          (AA)- Utredes innen Q4 2025
        </li>
        <li>
          Feilmeldinger gir ikke alltid tilstrekkelig veiledning (AA) -
          Forbedres innen utgangen av Q4 2025
        </li>
        <li>
          400 % zoom ved 1280 px bredde kan gi horisontal scrolling i enkelte
          filgallerier på web (AA) - Optimaliseres Q4 2025
        </li>
        <li>
          Tekst i eldre desktop-dialoger skaleres ikke alltid korrekt ved 200 %
          (AA) - Ny desktop-versjon innen Q1 2026
        </li>
        <li>
          Alle brukergrensesnittkomponenter skal vise synlig fokus når de mottar
          tastaturfokus (AAA) (mangler i desktop-appene - Planlagt utredet innen
          Q4 2025
        </li>
        <li>
          Tilby mekanismer for å identifisere uttale av ord (AAA) - Planlagt
          utredet innen Q2 2026
        </li>
        <li>
          Fyll ut tidligere informasjon automatisk eller gjør det tilgjengelig
          for valg (AAA) - Planlagt utredet innen Q4 2025
        </li>
      </ul>

      <h2>Hvordan jobber vi med universell utforming?</h2>
      <ul>
        <li>
          Kontinuerlig forbedring av rutiner for å sikre at nye produkter og
          tjenester er universell utformet
        </li>
        <li>
          Alle nye komponenter testes mot WCAG 2.1 nivå AA før de blir en del av
          designsystemet.
        </li>
        <li>Klar og tydelig språkbruk i alle tjenester vi tilbyr</li>
        <li>Regelmessige gjennomgang av eksisterende løsninger</li>
        <li>
          Kontinuerlig forbedring av rutiner for å sikre at nye produkter og
          tjenester er universell utformet
        </li>
        <li>
          Når vi oppdager problemer (via interne tester, support eller partnere)
          logges de i vårt system med og tas med i fremtidig utvikling
        </li>
      </ul>

      <h2>Hjelp oss å bli bedre</h2>

      <p>
        Opplever du hindringer, eller synes språket er vanskelig? Gi oss gjerne
        beskjed. Alle tilbakemeldinger hjelper oss å bli mer tilgjengelige!
      </p>

      <ul>
        <li>E-post: support@jottacloud.com</li>
        <li>
          Kontakt vårt kundesenter på (+ 47) 21 04 29 00 eller bruk chatten i
          appen/på web
        </li>
      </ul>
    </article>
  )
}
